import {SettingsState} from "@service/store/types/SettingsState";

export const state: SettingsState = {
    languages: null
}
